<template>
  <div class="foot">
    <div class="text">
      <p>关于我们 &nbsp; &nbsp; | &nbsp; &nbsp;</p>
      <p>联系我们 &nbsp; &nbsp;| &nbsp; &nbsp;</p>
      <p>服务声明 &nbsp; &nbsp;| &nbsp; &nbsp;</p>
      <p>隐私条约&nbsp; &nbsp;| &nbsp; &nbsp;</p>
      <p>
        <a style="color: #DDDDDE;" href="https://beian.miit.gov.cn" target="_blank">备案号：京ICP备20005715号-1</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detailFoot',
  props: {
    cardInfo: {
      type: Object,
      reuired: true
    },
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted() {
    // console.log(this.cardInfo.imgUrl, 1111)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
.foot {
  height: 5em;
  background: #2D6CAC;
  line-height: 5em;

  .text {
    text-align: center;
    display: flex;
    justify-content: center;
    color: #DDDDDE;
    font-size: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/detailFooter.vue